export const isMissingCurrencyCode = currency => {
  // no value, or the empty string
  const hasNoCurrencyCode = !currency || !currency.currencyCode;
  return hasNoCurrencyCode;
};